import { Input, Button } from "antd";
import { useState } from "react";

export const Home = () => {
  const [input, setInput] = useState("");
  return (
    <div className="w-100 h-[60vh] flex items-center justify-center">
      <div className="w-1/2 flex flex-col space-y-4 items-center">
        <Input
          onChange={(e) => setInput(e.target.value)}
          onPressEnter={() => {
            console.log("second", input);
          }}
        />
        <Button className="w-fit" onClick={() => console.log("first", input)}>
          Tra cứu
        </Button>
      </div>
    </div>
  );
};
